import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { formatDate } from "@/lib/format";
import { Button } from "@/components/ui/button";

export default function DueDateInline({ task, canEdit, onChange, field = "due_date", label = "Due" }) {
  const [open, setOpen] = useState(false);
  const value = task[field] ? new Date(task[field]) : undefined;

  const trigger = (
    <button
      disabled={!canEdit}
      onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center gap-1 text-xs hover:opacity-80 transition-opacity"
      data-testid={`inline-${field}-${task.id}`}
    >
      {task[field] ? (
        <>
          <CalendarIcon className="w-3 h-3 text-neutral-400" />
          <span className="text-neutral-700 font-mono-data">{formatDate(task[field])}</span>
        </>
      ) : (
        <span className="text-neutral-300 flex items-center gap-1"><CalendarIcon className="w-3.5 h-3.5" />{canEdit ? label : "—"}</span>
      )}
    </button>
  );

  if (!canEdit) return trigger;

  const handleSelect = (date) => {
    if (!date) return;
    onChange(date.toISOString());
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" onClick={(e) => e.stopPropagation()}>
        <div className="p-2 border-b border-neutral-200 flex items-center justify-between">
          <span className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-neutral-500">{label}</span>
          {task[field] && (
            <Button
              variant="ghost"
              size="sm"
              onClick={(e) => { e.stopPropagation(); onChange(""); setOpen(false); }}
              className="h-6 px-2 text-[11px]"
              data-testid={`inline-${field}-clear-${task.id}`}
            >
              <X className="w-3 h-3 mr-1" />Clear
            </Button>
          )}
        </div>
        <Calendar
          mode="single"
          selected={value}
          onSelect={handleSelect}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
